/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useState } from 'react'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Anchor, FrameInset } from '@nexigendigital/nxui'
import { useProductQuery } from 'api/shop'

import Nav from 'components/nav/nav'
import MiniCart from 'containers/shop/cart/miniCart'
import Products from 'containers/shop/products'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    product: string,
    setProduct: (product: string) => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Shop() {
    const [product, setProduct] = useState('domains')

    useProductQuery(process.env.REACT_APP_WEB_HOSTING)

    return (
        <FrameInset
            inset={'split'}
            location={{ pathname: '/Shop' }}
            left={{
                render: <ProductsSidebar product={product} setProduct={setProduct}/>
            }}
            right={{
                render: (
                    <section>
                        <Products name={product}/>
                        <MiniCart/>
                    </section>
                )
            }}
        />
    )
}

function ProductsSidebar({ product, setProduct }: Props) {
    return (
        <ProductSidebarWrapper>
            <Nav>
                <Anchor
                    className={`${product === 'domains' ? 'selected' : ''}`}
                    onClick={() => setProduct('domains')}
                >
                    Domain Name
                </Anchor>
                <Anchor
                    className={`${product === 'web-hosting' ? 'selected' : ''}`}
                    onClick={() => setProduct('web-hosting')}
                >
                    Web Hosting
                </Anchor>
            </Nav>
        </ProductSidebarWrapper>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const ProductSidebarWrapper = styled.div`
    width: 100%;
`
